import React from 'react'
import PropTypes from 'prop-types'
import { Select, Radio } from 'antd'
import styles from './Component.css'

export default class _Filters_ extends React.PureComponent {

  static propType = {
    filters: PropTypes.object.isRequired,
    clients: PropTypes.array.isRequired,
    onChangeFilter: PropTypes.func.isRequired,
  }

  render () {

    const {
      filters,
      clients,
      onChangeFilter,
    } = this.props

    const defaultSelectProps = {
      style: { width: 230 },
      showArrow: true,
      showSearch: true,
      allowClear: true,
      notFoundContent: null,
      defaultActiveFirstOption: true,
      filterOption: (value, option) => option.props.children.toLowerCase().includes(value.toLowerCase())
    }

    const statusOptions = [
      { value: 'ALL', label: 'All' },
      { value: 'INSUFFICIENT', label: 'Insufficient' },
      { value: 'MUTED', label: 'Muted' },
      { value: 'OK', label: 'Up to date' },
    ]

    return (

      <div className={styles.wrapper}>

        <Radio.Group
          value={filters.status}
          onChange={(event) => onChangeFilter('status', event.target.value)}
        >
          {statusOptions.map(option => (
            <Radio.Button
              className={styles.radio}
              value={option.value}
              key={option.value}
            >
              {option.label}
            </Radio.Button>
          ))}
        </Radio.Group>

        <div style={{ width: 10 }} />

        <Select
          {...Object.assign({}, defaultSelectProps)}
          placeholder="Filter by Client"
          value={filters.client_id}
          onChange={(value) => onChangeFilter('client_id', value)}
          mode="multiple"
        >

          {clients.map(client => (
            <Select.Option key={client.id}>
              {`${client.name}`}
            </Select.Option>
          ))}

        </Select>

      </div>

    )
  }
}
